// To use in a project:
// Initialise module in application.js
// import EntranceTransitions from './modules/entrance-transitions'
// $('[data-entrance]').map((i, el) => new EntranceTransitions(el))
// Add entrance class to html
//    <div class="a-slide-left"></div>

export default class EntranceTransitions {
    constructor(el) {
        this.el = el
        this.config = {
            rootMargin: '-20%',
            threshold: 0,
        }
        this.direction = this.el.dataset.direction
        this.page = document.querySelector('.page')
        this.class = 'animate'
        if (
            !window.IntersectionObserver ||
            (this.page && this.page.classList.contains('page-edit-mode'))
        ) {
            el.classList.toggle(this.class)
            return false
        }

        this.toggleAnimateClass()
    }

    toggleAnimateClass = () => {
        const thisDefault = this
        const observer = new IntersectionObserver((entries, self) => {
            const entry = entries[0]
            if (entry.isIntersecting) {
                entry.target.classList.add(thisDefault.class)
                if (thisDefault.direction !== 'alternate') {
                    self.unobserve(entry.target)
                }
            } else {
                if (thisDefault.direction === 'alternate') {
                    entry.target.classList.remove(thisDefault.class)
                }
            }
        }, this.config)

        observer.observe(this.el)
    }
}
